// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"bb2912a0","498":"5860fbe9","703":"55299b1b"}[chunkId] + ".chunk.js";
};